import type React from "react"

export enum NavbarMenuItemEnum {
    PURCHASED_REQUEST = "purchase_request",
    INVOICE_REQUEST = "invoice_request",
    REIMBURSEMENT_REQUEST = "reimbursement_request",
    TRIP_FOLDER_REQUEST = "trip_folder_request",
    SUBSCRIPTION = "subscription",
    EMPLOYEE = "employee",
    COST_CENTER = "costCenter",
    VENDOR = "vendor",
    LOGOUT = "logout",
    HELP_CENTER = "helpCenter",
    PURCHASE_ORDER = "purchase_order",
    DELIVERY_NOTE = "delivery_note",
}

export interface MenuItemInterface {
    link: NavbarMenuItemEnum
    label: string
    afterLabel?: React.ReactNode
    icon: React.ReactNode
    canView?: boolean
}
